import type { PropertyOwnerApprovalDto } from './contracts/approvalContracts'
import type { PropertyOwnerApproval } from '../types/propertyOwnerTypes'
import { PROPERTY_OWNER_STATUS, ENTITY_TYPE } from '../constants/propertyOwnerStatus'

export const parsePropertyOwnerApproval = (
  data: PropertyOwnerApprovalDto,
): PropertyOwnerApproval => {
  const firstName = data.firstName ?? ''
  const lastName = data.lastName ?? ''

  const phoneCountryCode = data.phoneCountryCode ?? ''
  const phoneNumber = data.phoneNumber ?? ''
  const phone =
    data.phone ??
    (phoneCountryCode && phoneNumber ? `${phoneCountryCode} ${phoneNumber}` : phoneNumber || '')

  return {
    id: String(data.id ?? ''),
    firstName,
    lastName,
    ownerName: [firstName, lastName].filter(Boolean).join(' '),
    email: data.email ?? '',
    phone,
    phoneCountryCode: data.phoneCountryCode ?? null,
    phoneNumber: data.phoneNumber ?? null,
    propertyOwnerType:
      (data.propertyOwnerType as PropertyOwnerApproval['propertyOwnerType']) ??
      ENTITY_TYPE.INDIVIDUAL,
    propertyOwnerStatus:
      (data.propertyOwnerStatus as PropertyOwnerApproval['propertyOwnerStatus']) ??
      PROPERTY_OWNER_STATUS.PENDING_REVIEW,
    ctrlAltStatus: (data.ctrlAltStatus as PropertyOwnerApproval['ctrlAltStatus']) ?? undefined,
    dateOfBirth: data.dateOfBirth ?? null,
    nationalityCountryId: data.nationalityCountryId ?? null,
    nationalityCountryName: data.nationalityCountryName ?? null,
    residenceCountryId: data.residenceCountryId ?? null,
    residenceCountryName: data.residenceCountryName ?? null,
    portalFirstLoginAt: data.portalFirstLoginAt ?? null,
    lastActiveAt: data.lastActiveAt ?? null,
    // Left null when the endpoint didn't resolve it. Not defaulted to 'admin':
    // consumers gate edit permission on this, and a wrong default grants it.
    onboardingSource: (data.onboardingSource as PropertyOwnerApproval['onboardingSource']) ?? null,
    invite: data.invite?.expiresAt
      ? {
          sentAt: data.invite.sentAt ?? null,
          firstResolvedAt: data.invite.firstResolvedAt ?? null,
          expiresAt: data.invite.expiresAt,
        }
      : null,
    rejectionReason: data.rejectionReason ?? null,
    blockReason: data.blockReason ?? null,
    createdAt: data.createdAt,
    updatedAt: data.updatedAt,
  }
}
